import request from "@/utils/request/request.js";

// 登录函数
/**
 * @description: 登录函数
 * @param {*} data { username,password}
 * @return {*} promise
 */

export function loginAPI(data) {
  return request.post("/admin/system/index/login", data);
}

// 获取用户信息
export function getUserInfoAPI() {
  return request.get("/api/user/info");
}

// 文档给的是put提交但是这里得用post提交
export function updatePasswordAPI(id, data) {
  return request.post(`/admin/system/sysUser/updatePassword/${id}`, data);
}

// 获取掩码手机号
export function getUserPhoneAPI(username) {
  return request.get("/admin/system/index/getMaskedPhone", {
    params: {
      username,
    },
  });
}

// 发送登录验证码
export function sendVerifyCodeAPI(username) {
  return request.post(
    "/admin/system/index/sendVerifyCode",
    {},
    {
      params: {
        username,
      },
    },
  );
}
